import { SelectionType as _ } from "../reducer/businessModal.types.js";
const a = (s, n) => {
  const {
    selectedBusinessIds: o = [],
    unselectedBusinessIds: i = [],
    selectedGroupIds: e = [],
    searchCity: c = "",
    searchOrg: d = "",
    selection: u
  } = n ?? {}, r = o.length > 0 || i.length > 0 || u === _.ALL, g = r ? c : "", b = r ? d : "";
  return {
    ...s,
    business__in: o.join(","),
    business__notin: i.join(","),
    business_city: g,
    business_org_id: b,
    groups: e.join(",")
  };
}, t = (s) => s ? s.split(",") : [], h = (s, n = []) => {
  const o = n.includes("business__in") ? t(s.business__in) : void 0, i = n.includes("business__notin") ? t(s.business__notin) : void 0, e = n.includes("groups") ? t(s.groups) : void 0, c = i && i.length > 0 ? _.ALL : _.UNSET, d = n.includes("business_city") ? s.business_city ?? void 0 : void 0, u = n.includes("org_id") || n.includes("business_org_id") ? s.org_id ? String(s.org_id) : s.business_org_id ?? void 0 : void 0;
  return {
    selectedBusinessIds: o,
    unselectedBusinessIds: i,
    selectedGroupIds: e,
    selection: c,
    searchCity: d,
    searchOrg: u
  };
};
export {
  h as convertFiltersToPreFilters,
  a as convertPreFiltersToFilters
};
